import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { AR_REPORTS_API } from "./apiRoutes";

interface UseGetARDetailedReportProps {
  communityId: string;
  reportDate?: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getARDetailedReport = async (communityId: string, reportDate?: any) =>
  await axiosAuth.get(
    reportDate
      ? `${AR_REPORTS_API(communityId)}/summary?reportDate=${reportDate}`
      : `${AR_REPORTS_API(communityId)}/summary`
  );

const useGetARDetailedReport = ({
  communityId,
  reportDate,
  queryParams,
}: UseGetARDetailedReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ar-360-reports-summary", communityId],
    queryFn: () => getARDetailedReport(communityId, reportDate),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetARDetailedReport;
